import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'
/**
 * link item
 * @augments {Component<Props, State>}
 */
class LoginField extends Component {
  static propTypes = {
    icon: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func
  }


  render() {
    const { icon, placeholder, type, onChange } = this.props
    return (
      <div className="login-field">
        <div className="icon">
          {icon}
        </div>
        <input type={type} placeholder={placeholder} onChange={evt => onChange && onChange(evt)} />
      </div>
    )
  }
}

export default LoginField